import { PermissionGroupResponse } from '../../core/openapi/identity';

export interface IPermissionGroup extends Omit<PermissionGroupResponse, 'permissions'> {
  hidden: boolean;
  permissions: IPermission[];
  selected: boolean;
}

export enum RolesAction {
  Create,
  Edit,
}

export interface IRoleModalData {
  title: string;
  action: RolesAction;
  roleId?: string;
}

export interface IRoleModalFormChecker {
  isFormModified: boolean;
}

export interface IPermission {
  id: string;
  name: string;
  selected: boolean;
}
